const Header = () => {
    return (
        <div className="header-container">
            <h3>NWICHURCH</h3>
            <h3>SELF ANALYSIS</h3>
        </div>
    );
};

export default Header;
